var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.238 3.334 2.173-2.172a.833.833 0 0 1 1.178 0l2.172 2.172h3.072c.46 0 .834.373.834.834v3.071l2.172 2.173a.833.833 0 0 1 0 1.178l-2.172 2.172v3.072c0 .46-.373.834-.834.834h-3.072L10.59 18.84a.833.833 0 0 1-1.178 0l-2.173-2.172H4.167a.833.833 0 0 1-.834-.834v-3.072L1.161 10.59a.833.833 0 0 1 0-1.178l2.172-2.173V4.168c0-.46.373-.834.834-.834h3.071ZM5 5.001V7.93L2.929 10l2.07 2.072v2.929h2.93l2.07 2.071 2.072-2.071H15v-2.929l2.071-2.071L15 7.93V5H12.07L10 2.93 7.929 5h-2.93Zm5 8.333a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666Zm0-1.666a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.6357f50424a28fc04f2fdb280236f6c6.svg";
export { ForwardRef as ReactComponent };